import React, { useState } from 'react';
import { dropdownArrow } from '../../assets/images/icons';

const CollapsibleCheckboxFilter = ({
    title,
    options,
    defaultOpen = false,
    withDivider = true,
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const handleChange = (index) => {
        const option = options[index];
        if (option.checked) {
            option.onUncheck?.();
        } else {
            option.onChange();
        }
    };

    return (
        <div className="collapsible-checkbox-filter">
            <div
                className="collapsible-checkbox-filter__header"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="collapsible-checkbox-filter__title">
                    {title}
                </span>
                <span
                    className={`collapsible-checkbox-filter__chevron ${
                        isOpen ? 'open' : ''
                    }`}
                >
                    <img
                        src={dropdownArrow}
                        width={24}
                        height={24}
                        alt="arrow"
                    />
                </span>
            </div>
            {isOpen && (
                <div className="collapsible-checkbox-filter__options">
                    {options.map((option, index) => (
                        <label
                            key={index}
                            className="collapsible-checkbox-filter__option"
                        >
                            <span
                                className={`collapsible-checkbox-filter__checkbox ${
                                    option.checked ? 'checked' : ''
                                }`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleChange(index);
                                }}
                            />
                            <span
                                className="collapsible-checkbox-filter__label"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleChange(index);
                                }}
                            >
                                {option.label}
                                {option.count !== undefined &&
                                    option.count !== null && (
                                        <span className="collapsible-checkbox-filter__count">
                                            ({option.count})
                                        </span>
                                    )}
                            </span>
                        </label>
                    ))}
                </div>
            )}
            {withDivider && (
                <div className="collapsible-checkbox-filter__divider" />
            )}
        </div>
    );
};

export default CollapsibleCheckboxFilter;
